import Login from "../Pages/Login"
import { useIsAuthenticated } from "@azure/msal-react"

function ProtectedRoute({ children }) {
    const isAuthenticated = useIsAuthenticated()
    return isAuthenticated ? children : <Login />
}
export default ProtectedRoute
